export default __webpack_public_path__ + "static/vector-shape5-f52267d0d27c924e3e395eba31ea0057.png";